import React from 'react'
import { Images } from '../../assets/scripts/Images'

function LeftSection() {
  let position_center = 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'
  return (
    <div className={'hidden lg:block lg:w-1/2 h-screen relative bg-[#EEEEEE] dark:bg-gray-800'}>
      <img
        src={Images.lightLogo}
        className={`hidden dark:block ${position_center}`}
        alt="milani auto clinic"
      />
      <img
        src={Images.logo}
        className={`block dark:hidden ${position_center}`}
        alt="milani auto clinic"
      />
    </div>
  )
}

export default React.memo(LeftSection)
